import { brl, fmtDateTime } from "@/lib/api";

const Row = ({ l, v, cls = "", testId }) => <div className={`flex justify-between gap-2 ${cls}`} data-testid={testId}><span>{l}</span><span className="font-mono whitespace-nowrap">{v}</span></div>;

function Moves({ list, sign }) {
  return list.map((m) => (
    <Row key={m.id} cls="pl-3 text-[11px] opacity-80" l={`${fmtDateTime(m.at)} · ${m.note || "sem motivo"} · ${m.user}`} v={`${sign} ${brl(m.amount)}`} />
  ));
}

export function CashBreakdown({ session, summary: s }) {
  const moves = session.movements || [];
  const of = (t) => moves.filter((m) => m.type === t);
  return (
    <div className="space-y-1" data-testid="cash-breakdown">
      <p className="font-bold">Dinheiro em caixa</p>
      <Row l="Valor inicial em dinheiro" v={brl(session.opening_amount)} testId="breakdown-opening" />
      <Row l="Vendas em dinheiro" v={`+ ${brl(s.by_method?.dinheiro || 0)}`} testId="breakdown-cash-sales" />
      <Row l={`Suprimentos (${of("suprimento").length})`} v={`+ ${brl(s.suprimentos)}`} testId="breakdown-suprimentos" />
      <Moves list={of("suprimento")} sign="+" />
      <Row l={`Sangrias (${of("sangria").length})`} v={`- ${brl(s.sangrias)}`} testId="breakdown-sangrias" />
      <Moves list={of("sangria")} sign="-" />
      {s.entradas > 0 && <><Row l="Entradas" v={`+ ${brl(s.entradas)}`} /><Moves list={of("entrada")} sign="+" /></>}
      {s.saidas > 0 && <><Row l="Saídas / despesas" v={`- ${brl(s.saidas)}`} /><Moves list={of("saida")} sign="-" /></>}
      <Row l="Dinheiro esperado" v={brl(s.expected_cash)} cls="border-t border-dashed pt-1 font-bold" testId="breakdown-expected" />
    </div>
  );
}
